import { render } from "./ClientAgreeModal.vue?vue&type=template&id=06eb6919&scoped=true"
import script from "./ClientAgreeModal.vue?vue&type=script&lang=js"
export * from "./ClientAgreeModal.vue?vue&type=script&lang=js"

import "./ClientAgreeModal.vue?vue&type=style&index=0&id=06eb6919&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eb6919"]])

export default __exports__